import './App.css';
import Landing from './components/Landing/Landing';

function App() {
  return (
    <Landing />
  );
}

export default App;
